<script lang="ts" setup>
import { addStickyClass } from '~/utils/addStickyClass'
import { Routes } from '~/enums/Routes'
import getLocalizedRoute from '~/utils/getLocalizedRoute'
import LayoutEnum from '~/enums/LayoutEnum'
import { useStoreConfig } from '~/store/storeConfig'

const { type } = defineProps<{ type?: LayoutEnum.Market | LayoutEnum.Quote }>()
const headerRef = ref<HTMLDivElement>()
const placeholderRef = ref<HTMLDivElement>()
const logos = await useAssetManager().getLogos()
const { t } = useLang()

const scrollHandler = () => addStickyClass(headerRef.value, placeholderRef.value)
const storeConfig = useStoreConfig()

onMounted(() => {
  addStickyClass(headerRef.value)
  window?.addEventListener('scroll', scrollHandler)
})

onBeforeUnmount(() => {
  window?.removeEventListener('scroll', scrollHandler)
})
</script>

<template>
  <header :key="storeConfig.getIsMobile.valueOf.toString()" :class="{ 'desktop-header': true, [type!]: Boolean(type) }">
    <section ref="headerRef" class="flex flex-col w-full">
      <div class="bg-brand-primary w-full py-2">
        <div class="flex justify-between max-w-xlg w-full lg:px-[15px] m-auto">
          <Language />
          <div class="flex gap-4 text-sm [&>a]:hover:text-white">
            <HeaderTracking />
            <NuxtLink :to="getLocalizedRoute(Routes.Blog)">
              {{ t('common.blog') }}
            </NuxtLink>
            <NuxtLink :to="getLocalizedRoute(Routes.Contacts)">
              {{ t('common.contact-us') }}
            </NuxtLink>
            <NuxtLink :to="getLocalizedRoute(Routes.Contacts)">
              {{ t('common.faq') }}
            </NuxtLink>
            <NuxtLink :to="getLocalizedRoute(Routes.Pro)">
              {{ t('common.site-pro') }}
            </NuxtLink>
          </div>
        </div>
      </div>

      <div class="flex max-w-xlg w-full items-center lg:px-[15px] m-auto">
        <NuxtLink :to="getLocalizedRoute(Routes.Index)">
          <img :src="logos.logo" class="logo" alt="Logo" />
        </NuxtLink>
        <NavbarWl :type="type" />

        <div class="profile flex items-center h-full justify-end">
          <!-- <SearchBar mini /> -->
          <!-- <HeaderCart /> -->
          <HeaderAccountWl />
        </div>
      </div>
    </section>
    <div ref="placeholderRef" class="header-placeholder" />
  </header>
</template>

<style lang="postcss" scoped>
.wl .desktop-header {
  border-bottom: 1px solid theme('colors.neutral6');
  background-color: theme('colors.white');
  width: 100%;
  color: theme('colors.white');

  .vertical-divider {
    box-sizing: border-box;
    margin: 0 1rem 0 1rem;
    height: 23px;
    width: 1px;
  }

  .profile {
    gap: 8px;
    margin-left: auto;
    padding-left: 2rem;
    max-width: 750px;
    width: 100%;
  }

  .sticky {
    position: fixed !important;
    z-index: 33;
    background-color: theme('colors.white');
    width: 100%;
    left: 0;
    top: 0;
    border-bottom: 1px solid theme('colors.neutral6');

    & + .header-placeholder {
      height: 67px;
    }
  }

  &.tp {
    .sticky.header-placeholder {
      height: 101px;
    }
  }
}
</style>
